/**
 * @flow
 * @relayHash b3c8e155b9fa9bc984f7640813594a92
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WellbeingSurveyQueryVariables = {||};
export type WellbeingSurveyQueryResponse = {|
  +nextPeriod: ?any,
  +questions: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +displayType: string,
        +name: string,
        +text: string,
        +validation: string,
      |}
    |}>
  |},
|};
export type WellbeingSurveyQuery = {|
  variables: WellbeingSurveyQueryVariables,
  response: WellbeingSurveyQueryResponse,
|};
*/


/*
query WellbeingSurveyQuery {
  nextPeriod
  questions {
    edges {
      node {
        id
        displayType
        name
        text
        validation
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "nextPeriod",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "questions",
    "storageKey": null,
    "args": null,
    "concreteType": "QuestionNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "QuestionNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "QuestionNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "text",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "validation",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "WellbeingSurveyQuery",
    "type": "RelayQuery",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "WellbeingSurveyQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "WellbeingSurveyQuery",
    "id": null,
    "text": "query WellbeingSurveyQuery {\n  nextPeriod\n  questions {\n    edges {\n      node {\n        id\n        displayType\n        name\n        text\n        validation\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0ee25c8fcb423b7785a44860083fa6cc';
module.exports = node;
